// import React, { useState } from "react";

// import ManagementTeamBODTab from "./ManagementTeamTab/ManagementTeamBODTab";
// import ManagementTeamPOTab from "./ManagementTeamTab/ManagementTeamPOTab";
// import ManagementTeamRMTab from "./ManagementTeamTab/ManagementTeamRMTab";
// import ManagementTeamEMTab from "./ManagementTeamTab/ManagementTeamEMTab";


// function ManagementTeam() {

//   const [currentSection, setCurrentSection] = useState("section1");
  
//     const handleClick = (section) => {
//       setCurrentSection(section);
  
//       const closeBtn = document.querySelector(".btn-cus");
//       if (closeBtn) {
//         closeBtn.click();
//       }
//     };

 

//   return (
//     <>
//       <section className="ManagementTeam px-3 small-anchor" id="management-team">
//         <div className="container max-1330 mx-auto">
//           <div className="row g-3 g-sm-4 g-md-5">
//             <div className="col-12">
//               <h1 className="section-title text-center">Board of Directors</h1>
//               <p className="text-center mb-5 d-none">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's<br className="d-none d-md-block" /> standard dummy text ever sinc</p>
//             </div>
//             <div className="col-lg-3 col-md-4">
       

//               <div className="d-md-none text-end">
//                 <i class="bi bi-list  border-0 ms-auto font-32" data-bs-toggle="offcanvas"
//                 data-bs-target="#offcanvasResponsive"
//                 aria-controls="offcanvasResponsive"></i>
//               </div>
//               <div
//                 class="offcanvas-md offcanvas-end"
//                 tabindex="-1"
//                 id="offcanvasResponsive"
//                 aria-labelledby="offcanvasResponsiveLabel"
//               >
//                 <div class="offcanvas-header d-md-none">
//                   <h5 class="offcanvas-title" id="offcanvasResponsiveLabel">
//                     {/* Management Team */}
//                     SAMSA Leadership
//                   </h5>


//                   <button
//                       type="button"
//                       class="btn-close btn-cus"
//                       data-bs-dismiss="offcanvas"
//                       data-bs-target="#offcanvasResponsive"
//                       aria-label="Close"
//                     ></button>
//                 </div>
//                 <div className="accordion leftMenu px-3 px-md-0 pb-3 pb-md-0 overflow-auto overflow-md-visible" id="accordionExample">
//                   <div className="accordion-item">
//                     <h2 className="accordion-header">
//                       <button
//                         className={`accordion-button ${currentSection === "section1" ? "collapsed gray-active" : "collapsed"}`} onClick={() => handleClick("section1")}
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#collapseOne"
//                         aria-expanded="false"
//                         aria-controls="collapseOne"
//                       >
//                         BOARD OF DIRECTORS
//                       </button>
//                     </h2>
             
//                   </div>
//                   <div className="accordion-item">
//                     <h2 className="accordion-header">
//                       <button
//                         className={`accordion-button ${currentSection === "section2" ? "collapsed gray-active" : "collapsed"}`} onClick={() => handleClick("section2")}
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#collapseTwo"
//                         aria-expanded="false"
//                         aria-controls="collapseTwo"
//                       >
//                         EXECUTIVE MANAGEMENT
//                       </button>
//                     </h2>
                  
//                   </div>
//                   <div className="accordion-item">
//                     <h2 className="accordion-header">
//                       <button
//                         className={`accordion-button ${currentSection === "section3" ? "collapsed gray-active" : "collapsed"}`} onClick={() => handleClick("section3")}
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#collapseThree"
//                         aria-expanded="false"
//                         aria-controls="collapseThree"
//                       >
//                         REGIONAL MANAGERS
//                       </button>
//                     </h2>
               
//                   </div>
//                   <div className="accordion-item">
//                     <h2 className="accordion-header">
//                       <button
//                         className={`accordion-button ${currentSection === "section4" ? "collapsed gray-active" : "collapsed"}`} onClick={() => handleClick("section4")}
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#collapseFourth"
//                         aria-expanded="false"
//                         aria-controls="collapseFourth"
//                       >
//                         PRINCIPAL OFFICERS
//                       </button>
//                     </h2>
                 
//                   </div>
                 
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-9 col-md-8">
//               <div className="row g-3 g-sm-3 g-md-4">
//                 {currentSection === "section1" && (
//                   <ManagementTeamBODTab/>
//                 )}

//                 {currentSection === "section2" && (
//                   <ManagementTeamEMTab/>
//                 )}


//                 {currentSection === "section3" && (
//                  <ManagementTeamRMTab/>
//                 )}


//                 {currentSection === "section4" && (
//                   <ManagementTeamPOTab/>
//                 )}


                
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// export default ManagementTeam;

import React, { useState } from "react";

import ManagementTeamBODTab from "./ManagementTeamTab/ManagementTeamBODTab";
import ManagementTeamPOTab from "./ManagementTeamTab/ManagementTeamPOTab";
import ManagementTeamRMTab from "./ManagementTeamTab/ManagementTeamRMTab";
import ManagementTeamEMTab from "./ManagementTeamTab/ManagementTeamEMTab";

function ManagementTeam() {
  const [currentSection, setCurrentSection] = useState("section1");

  const sectionHeadings = {
    section1: "Board of Directors",
    section2: "Executive Management",
    section3: "Regional Managers",
    section4: "Principal Officers",
  };

  const handleClick = (section) => {
    setCurrentSection(section);

    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) {
      closeBtn.click();
    }
  };

  return (
    <>
      <section className="ManagementTeam px-3 small-anchor" id="management-team">
        <div className="container max-1330 mx-auto">
          <div className="row g-3 g-sm-4 g-md-5">
            <div className="col-12">
              <h1 className="section-title text-center">
                {sectionHeadings[currentSection]}
              </h1>
              <p className="text-center mb-5 d-none">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's
                <br className="d-none d-md-block" />
                standard dummy text ever sinc
              </p>
            </div>

            <div className="col-lg-3 col-md-4">
              <div className="d-md-none text-end">
                <i
                  className="bi bi-list border-0 ms-auto font-32"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasResponsive"
                  aria-controls="offcanvasResponsive"
                ></i>
              </div>

              <div
                className="offcanvas-md offcanvas-end"
                tabIndex="-1"
                id="offcanvasResponsive"
                aria-labelledby="offcanvasResponsiveLabel"
              >
                <div className="offcanvas-header d-md-none">
                  <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
                    SAMSA Leadership
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-cus"
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="accordion leftMenu px-3 px-md-0 pb-3 pb-md-0 overflow-auto overflow-md-visible" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection === "section1" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("section1")}
                        type="button"
                      >
                        BOARD OF DIRECTORS
                      </button>
                    </h2>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection === "section2" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("section2")}
                        type="button"
                      >
                        EXECUTIVE MANAGEMENT
                      </button>
                    </h2>
                  </div>
                  {/* <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection === "section3" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("section3")}
                        type="button"
                      >
                        REGIONAL MANAGERS
                      </button>
                    </h2>
                  </div> */}
                  {/* <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection === "section4" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("section4")}
                        type="button"
                      >
                        PRINCIPAL OFFICERS
                      </button>
                    </h2>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-8">
              <div className="row g-3 g-sm-3 g-md-4">
                {currentSection === "section1" && <ManagementTeamBODTab />}
                {currentSection === "section2" && <ManagementTeamEMTab />}
                {currentSection === "section3" && <ManagementTeamRMTab />}
                {currentSection === "section4" && <ManagementTeamPOTab />}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ManagementTeam;
